export default {"src":"/_next/static/media/pitch-icon.f758c203.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};